import { Component, OnInit } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';

@Component({
    selector: 'app-kue',
    templateUrl: './kue.component.html',
    styleUrls: ['./kue.component.scss'],
    standalone: false
})
export class KueComponent implements OnInit {

  public pageActions: PageAction[];

  constructor() {
  }

  ngOnInit() {
    this.createPageActions();
  }

  private createPageActions(): void {

  }
}
